export interface FormItemDef {
  name: string;
  dataField: string;
  validation?: any;
}

export interface FormDef {
  type?: string;
  items?: FormItemDef[];
}

export interface GetFormValuesParams {
  def: FormDef;
  data: Record<string, any>;
  isAddressType: boolean;
}

export interface GetFormValuesResult {
  initialValues: Record<string, any>;
  validationSchema: Record<string, any>;
}

/**
 * Builds initial form values and a validation schema based on a form definition.
 */
export function getFormValues({
  def,
  data,
  isAddressType,
}: GetFormValuesParams): GetFormValuesResult {
  const initialValues: Record<string, any> = {};
  const validationSchema: Record<string, any> = {};

  const addressObj: Record<string, any> =
    (isAddressType && def.type && data[def.type]) ||
    data.address ||
    {};

  def.items?.forEach((item) => {
    const { name, dataField, validation } = item;

    if (validation) {
      validationSchema[name] = validation;
    }

    if (name === "validFrom") {
      initialValues.validFrom = data.validFrom
        ? new Date(data.validFrom)
        : new Date();
      return;
    }
    if (name === "initialMessage") {
      initialValues.initialMessage = data.initialMessage ?? "";
      return;
    }

    if (isAddressType) {
      switch (name) {
        case "streetType":
          initialValues.streetType = addressObj[dataField]
            ? { name: addressObj[dataField] as string }
            : null;
          break;
        case "city":
          initialValues.city = addressObj[dataField] ?? "";
          break;
        case "zip":
          initialValues.zip = addressObj[dataField] ?? "";
          break;
        default:
          // egyéb cím‐mezők, ha vannak
          initialValues[name] = addressObj[dataField] ?? "";
      }
      return;
    }

    if (def.type === "phones") {
      const arr = (data.phones as any[]) || [];
      const found = arr.find((e) => e.type === dataField);
      initialValues[name] = found?.number ?? "";
      return;
    }

    if (def.type === "emails") {
      const arr = (data.emails as any[]) || [];
      const found = arr.find((e) => e.type === dataField);
      initialValues[name] = found?.address ?? "";
      return;
    }

    initialValues[name] = data[dataField] ?? "";
  });

  return { initialValues, validationSchema };
}


export default getFormValues;
